import React, { FunctionComponent } from 'react';
import Text, { TextSize, TextBasicProps, TextCommonProps } from 'components/typography/text';

type Header1Pros = TextBasicProps & TextCommonProps;

const Header1: FunctionComponent<Header1Pros> = (props) => {
    const { children, align, color, isInline, hasEllipsis, hasBreakWords, isDangerous, tag } =
        props;

    return (
        <Text
            size={TextSize.HEADER1}
            align={align}
            color={color}
            isInline={isInline}
            hasEllipsis={hasEllipsis}
            hasBreakWords={hasBreakWords}
            isDangerous={isDangerous}
            tag={tag}
        >
            {children}
        </Text>
    );
};

export default Header1;
